import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=dd96cf74&scoped=true"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=dd96cf74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd96cf74",
  null
  
)

export default component.exports